import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { GrpcEvent, GrpcMessage, GrpcRequest } from '@ngx-grpc/common';
import { GrpcHandler, GrpcInterceptor } from '@ngx-grpc/core';
import { GrpcErrorCode } from '@shared/models/grpc-error-code';
import { UserLogout } from '@shared/store/user';
import { Observable, tap } from 'rxjs';

@Injectable()
export class UnauthorizedGrpcResponseInterceptor implements GrpcInterceptor {
  public constructor(
    private store: Store,
    private router: Router
  ) {}

  public intercept<Q extends GrpcMessage, S extends GrpcMessage>(
    request: GrpcRequest<Q, S>,
    next: GrpcHandler
  ): Observable<GrpcEvent<S>> {
    return next.handle(request).pipe(
      tap((statusEvent: GrpcEvent<S>) => {
        if ([GrpcErrorCode.PERMISSION_DENIED, GrpcErrorCode.UNAUTHENTICATED].includes(statusEvent['statusCode'])) {
          this.store.dispatch(new UserLogout());
          this.router.navigateByUrl('/user/login');
        }
      })
    );
  }
}
